export default __webpack_public_path__ + "static/media/Logo nano biocancer.6ca2632e.jpeg";